import { useCostTabStore, useStrategyStore } from '../../../../../store/strategy-store/strategy-store';
import {
  setPerformanceActivePanel,
  showEpicRelatedTasks,
  showTeamRelatedTasks,
} from '../../../../../store/strategy-store/strategy-store.actions';
import { Panel } from '../../../../../store/strategy-store/strategy-store.type';
import { SideSectionEpics } from '../../components/side-section-epics/side-section-epics';
import { SideSectionTeams } from '../../components/side-section-teams/side-section-teams';
import { getLatestDate } from '../../related-tasks-tab/related-tasks-tab.helpers';
import { CostMode } from '../cost-tab.type';
import { SideSectionOtherEpics } from './side-section-other-epics';
import { SideSectionOtherTeams } from './side-section-other-teams';

export const SideSection = () => {
  const initiative = useStrategyStore((state) => state.initiativePerformance);
  const mode = useCostTabStore((state) => state.mode);
  const performanceActivePanel = useStrategyStore((state) => state.performanceActivePanel);

  const epic = useCostTabStore((state) => state.selectedEpic);
  const team = useCostTabStore((state) => state.selectedTeam);

  const latestDate = getLatestDate(initiative);

  const onClose = () => {
    setPerformanceActivePanel(null);
  };

  const onClickEpicRelatedTasks = () => {
    if (!epic || !latestDate) {
      return;
    }

    showEpicRelatedTasks({ epic: epic.id, date: latestDate });
  };

  const onClickTeamRelatedTasks = () => {
    if (!team || !latestDate) {
      return;
    }

    showTeamRelatedTasks({ team: team.id, date: latestDate });
  };

  // Handle "Other" panels
  if (performanceActivePanel === Panel.OtherEpics) {
    return <SideSectionOtherEpics />;
  }

  if (performanceActivePanel === Panel.OtherTeams) {
    return <SideSectionOtherTeams />;
  }

  // Handle regular panels
  switch (mode) {
    case CostMode.ContributingEpics:
      return <SideSectionEpics epic={epic} onClose={onClose} onClickRelatedTasks={onClickEpicRelatedTasks} />;
    case CostMode.ContributingTeams:
      return <SideSectionTeams team={team} onClose={onClose} onClickRelatedTasks={onClickTeamRelatedTasks} />;
    default:
      return null;
  }
};
